import Vue from 'vue';
import VueI18n from 'vue-i18n';

const translations = {
	en: {
		chooseFile: 'Choose file',
		chooseFiles: 'Choose files',
        chooseLocation: 'Choose study location',
		chooseCountry: 'Choose country',
		chooseNationality: 'Choose nationality',
		nationality: 'Citizenship',
		personalInformation: 'Personal information',
		xFiles: '{count} files',
		groupStart: 'Group start',
		Dagundervisning: 'Day group',
		Aftenundervisning: 'Evening group',
		Fjernundervisning: 'Distance learning',
		place: 'Place',
		youSignupFor: 'You are applying for',
		youSignupForSuccess: 'You have applied to',
		youSignupForError: 'You tried to apply to',
		price: 'Price',
		yourInformation: 'Your contact information',
		firstName: 'First name',
		lastName: 'Last name',
		phone: 'Phone',
		payment: 'Payment',
		payer: 'Payer',
		employeer: 'Employeer',
		myEmployeer: 'My employeer',
		my: 'My',
		myself: 'Myself',
		address: 'Address',
		postalCode: 'Postal code',
		zipCode: 'Zip code',
		cprNumber: 'CPR-number',
		cvrNumber: 'CVR-number',
		eanNumber: 'EAN-number',
		admissionRequirements: 'Admission requirements',
		highestEducation: 'Previously highest achieved education',
		yearsOfExp: 'Years of experience',
		approvalOfConditions: 'I have read and accept the <a href="{termsLink}" target="_blank">terms</a>',
		uploadAdmissionDocuments: 'Upload admission documents',
		admissionDocuments: 'Admission documents',
		uploadAddFile: 'Add file',
		uploadRemoveFile: 'Remove',
		encryptedInfo: 'Your information is sent encrypted.',
		signup: 'Apply',
		notReq: 'Not required',
		extra: 'Extra',
		addComment: 'Add commentary',
		validateFirstName: 'First name',
		validateLastName: 'Last name',
		validatePhone: 'Phone',
		validateEmail: 'E-mail',
		validateCPR: 'CPR-number',
		validateCVR: 'CVR-number',
		validateEAN: 'EAN-number',
		validateAddr: 'Address',
		validateCity: 'City',
		validateCountry: 'Country',
		validateNationality: 'Citizenship',	
		validateZip: 'Zip code',
		validatePostalCode: 'Postal code',
		validateQuality: 'Achieved education',
		validateYearsOfExp: 'Experience',
		validateFiles: 'Files',
		validateGender: 'Gender',
		validateSignupLocation: 'Location',
		locationChoiceDisabledDisclaimer: 'There are only available seats in the shown locations',
		confirmationEmailSent: 'A confirmation email is sent to your inbox',
		confirmationEducationBooked: 'A confirmation email is sent to your inbox.<br>You will receive an admission letter in your e-box or via mail if you are accepted.',
		trySubmittingAgain: 'Push the button to try again',
		signupForEducation: 'Apply',
		signupForCourse: 'Apply',
		followEveryDay: 'Follow us on',
		seeImgsFromEveryDay: 'See pictures from everyday life',
		search: 'Search',
		date: 'Date',
		subjectAndLevel: 'Subject, Level',
		location: 'Location | Locations',
		priceAndDuration: 'Price, Duration',
		moreGroups: 'More groups',
		duration: 'Duration',
		upcomingGroup: 'Upcoming group | Upcoming groups',
		showMoreFilters: 'Show more filters',
		hideAdditionalFilters: 'Hide additional filters',
		all: 'All',
		educationStart: 'Start of term',
		AvailableSeats: 'Avaliable spots',
		readMore: 'Read more',
		noScheduledGroups: 'Unfortunately, there are currently no scheduled groups',
		vocationalTraining: 'Vocational training',
		academyEducation: 'Academy education',
		educationalBackground: 'Educational background',
		highschoolExam: 'Highschool exam',
		passedSubject: 'Passed subject',
		approvedForeignExam: 'Approved foreign exam',
		expBackground: 'Work experience or other relevant education',
		chooseBackground: 'Choose background',
		street: 'Address',
		city: 'City',
		Education: 'Programme',
		Courses: 'Course',
		Subjects: 'Subject',
		country: 'Country',
		visitPost: 'Visit post',
		January: 'January',
		February: 'February',
		March: 'March',
		April: 'April',
		May: 'May',
		June: 'June',
		July: 'July',
		August: 'August',
		September: 'September',
		October: 'October',
		November: 'November',
		December: 'December',
		courseDates: 'Course dates',
		haveCPR: 'I have a CPR number',
		noCPR: 'I do not have a CPR number',
		validateDateOfBirth: 'Date of birth',
		gender: 'Gender',
		selectGender: 'Select gender',
		male: 'Male',
		female: 'Female',
		DDMMYY: 'DDMMYY',
		otherHigherEducation: 'Other higher education',	
		otherWorkExperienceOrEducation: 'Work experience or relevant education',	
		yes: 'Yes',
		no: 'No',
		highSchoolDetailsYear: 'Graduation year',
		highSchoolDetailsType: 'Education type',
		highSchoolDetailsTypePlaceholder: 'Choose education',
        nameOfEducation: 'Name of education',
        previousEducationLabel: 'Previous higher education',
        nameOfHigherEducation: 'Name of higher education',
        previousEducation: 'I have previously completed a higher education',
        other: 'Other',
		signupLocation: 'Location to study',
		referral: {
			whereDidYouHearAboutEducation: 'Where did you hear about the education?',
			expandUponWhere: 'Expand upon where',
			choose: 'Choose',
			fak: 'Fremtidens Arbejdskraft (FAK)',
			advertising: 'Advertising',
			atConference: 'At a conference',
			other: 'Other',
		},	
	},
	da: {
		chooseFile: 'Vælg fil',
		chooseFiles: 'Vælg filer',
        chooseLocation: 'Vælg uddannelsessted',
		chooseCountry: 'Vælg land',
		chooseNationality: 'Vælg nationalitet',
		nationality: 'Statsborgerskab',
		personalInformation: 'Personlige informationer',		
		xFiles: '{count} filer',
		groupStart: 'Holdstart',
		Dagundervisning: 'Daghold',
		Aftenundervisning: 'Aftenhold',
		Fjernundervisning: 'Fjernundervisning',
		place: 'Sted',
		youSignupFor: 'Du tilmelder dig',
		youSignupForSuccess: 'Du er tilmeldt',
		youSignupForError: 'Der skete en fejl under tilmeldingen til',
		price: 'Pris',
		yourInformation: 'Dine kontaktoplysninger',
		firstName: 'Fornavn',
		lastName: 'Efternavn',
		phone: 'Telefon',
		payment: 'Betaling',
		payer: 'Betaler',
		employeer: 'Arbejdsgiver',
		myEmployeer: 'Min arbejdsgiver',
		my: 'Min',
		myself: 'Mig selv',
		address: 'Adresse',
		postalCode: 'Postdistrikt',
		zipCode: 'Postnummer',
		cprNumber: 'CPR-nummer',
		cvrNumber: 'CVR-nummer',
		eanNumber: 'EAN-nummer',
		admissionRequirements: 'Adgangskrav',
		highestEducation: 'Tidligere højeste opnåede uddannelse',
		yearsOfExp: 'Antal års erfaring',
		approvalOfConditions: 'Jeg har læst og accepterer <a href="{termsLink}" target="_blank">betingelserne</a>',
		uploadAdmissionDocuments: 'Upload adgangsgivende beviser',
		admissionDocuments: 'Adgangsgivende beviser',
		uploadAddFile: 'Tilføj fil',
		uploadRemoveFile: 'Fjern',
		encryptedInfo: 'Dine oplysninger sendes krypteret.',
		signup: 'Tilmeld',
		notReq: 'Ikke påkrævet',
		extra: 'Ekstra',
		addComment: 'Tilføj kommentar',
		validateFirstName: 'Feltet',
		validateLastName: 'Feltet',
		validatePhone: 'Feltet',
		validateEmail: 'E-mailen',
		validateCPR: 'Feltet',
		validateCVR: 'Feltet',
		validateEAN: 'Feltet',
		validateAddr: 'Feltet',
		validateCity: 'Feltet',
		validateCountry: 'Feltet',		
		validateNationality: 'Feltet',		
		validateZip: 'Feltet',
		validatePostalCode: 'Feltet',
		validateQuality: 'Feltet',
		validateYearsOfExp: 'Feltet',
		validateFiles: 'Feltet',
		validateTerms: 'Betingelserne',
		validateGender: 'Feltet',
		validateSignupLocation: 'Feltet',
		locationChoiceDisabledDisclaimer: 'Der er kun ledige pladser de viste steder',
		confirmationEmailSent: 'Vi har sendt en bekræftelse til din email',
		confirmationEducationBooked: 'Vi har sendt en bekræftelse til din email.<br>Du vil modtage et indkaldelsesbrev i din e-boks eller på mail, hvis du bliver optaget på uddannelsen.',
		trySubmittingAgain: 'Tryk på knappen for at prøve igen',
		signupForEducation: 'Ansøg',
		signupForCourse: 'Tilmeld',
		followEveryDay: 'Følg hverdagen på',
		seeImgsFromEveryDay: 'Se billeder fra hverdagen',
		search: 'Søg',
		date: 'Dato',
		subjectAndLevel: 'Fag, Niveau',
		location: 'Lokation | Lokationer',
		priceAndDuration: 'Pris, Varighed',
		moreGroups: 'Flere hold',
		duration: 'Varighed',
		upcomingGroup: 'Næste hold | Næste hold',
		showMoreFilters: 'Vis flere filtre',
		hideAdditionalFilters: 'Skjul ekstra filtre',		
		all: 'Alle',
		educationStart: 'Studiestart',
		AvailableSeats: 'Ledige pladser',
		readMore: 'Læs mere',
		noScheduledGroups: 'Der er desværre ikke nogle planlagte hold i øjeblikket',
		vocationalTraining: 'Erhvervsuddannelse',
		academyEducation: 'Akademiuddannelse',
		educationalBackground: 'Adgangsgrundlag',
		highschoolExam: 'Gymnasiel eksamen',
		passedSubject: 'Beståede fag',
		approvedForeignExam: 'Godkendt udenlandsk eksamen',
		expBackground: 'Erhvervserfaring eller anden relevant uddannelse',
		chooseBackground: 'Vælg grundlag',
		street: 'Vejnavn + husnummer',
		city: 'By',
		Education: 'Uddannelse',
		Courses: 'Efteruddannelse',
		Subjects: 'Fag',
		country: 'Land',
		visitPost: 'Se på Instagram',
		January: 'Januar',
		February: 'Februar',
		March:	'Marts',
		April: 'April',
		May: 'Maj',
		June: 'Juni',
		July: 'Juli',
		August: 'August',
		September: 'September',
		October: 'Oktober',
		November: 'November',
		December: 'December',
		courseDates: 'Kursusdage',
		haveCPR: 'Jeg har et CPR nummer',
		noCPR: 'Jeg har ikke et CPR nummer',
		validateDateOfBirth: 'Fødselsdato',
		gender: 'Køn',
		selectGender: 'Vælg køn',
		male: 'Mand',
		female: 'Kvinde',
		DDMMYY: 'DDMMÅÅ',
		otherHigherEducation: 'Anden videregående uddannelse',	
		otherWorkExperienceOrEducation: 'Erhvervserfaring eller anden relevant uddannelse',			
		yes: 'Ja',
		no: 'Nej',	
		highSchoolDetailsYear: 'Eksamensår',
		highSchoolDetailsType: 'Uddannelse',
		highSchoolDetailsTypePlaceholder: 'Vælg uddannelse',
        nameOfEducation: 'Navn på uddannelse',
        previousEducationLabel: 'Tideligere videregående uddannelse',
        nameOfHigherEducation: 'Navn på videregående uddannelse',
        previousEducation: 'Jeg har tidligere fuldført en videregående uddannelse',
        other: 'Andet',
		signupLocation: 'Ønsket studiested',
		referral: {
			whereDidYouHearAboutEducation: 'Hvor har du hørt om uddannelsen?',
			expandUponWhere: 'Uddyb hvor',
			choose: 'Vælg',
			fak: 'Fremtidens Arbejdskraft (FAK)',
			advertising: 'Annoncering',
			atConference: 'På messe',
			other: 'Andet',
		},	
	},
};

// Create VueI18n instance with options
Vue.use( VueI18n );

export const i18n = new VueI18n({
	locale: 'da', // set locale
	messages: translations, // set locale messages
});



// WEBPACK FOOTER //
// ./assets/_js/translation.js